import {
    HeroUserCircleIcon, XIcon,
} from 'components/Icon'

import React, {useContext} from 'react'

import {
    buttonsWrapper, closeButton, content, contentInner, footer, header, heading, iconWrapper, text as styledText,
} from './../styles'
import {
    useForm, useWatch,
} from 'react-hook-form'

import Button from 'components/Button'
import {DEFAULT_HEADER_HEIGHT} from 'components/Embed/components/EmbedHeader/EmbedHeader'
import {EmbedContext} from 'components/EmbedContext'
import {EmbedPromiseModalProps} from './types'
import {
    Modal,
} from 'components/Modal'
import {ThemeContext} from 'stitches/ThemeProvider/ThemeProvider'

import {embedTheme} from 'stitches/themes'

import {
    styled,
} from 'stitches/config'

import {
    styledInput,
} from 'components/Form/styles/FormView'

import {updateUser} from 'api/action/updateUser'
import {useAppDispatch} from 'hooks'
import {useTranslation} from 'react-i18next'

const Input = styled('input', {
    ...styledInput,
    boxSizing: 'border-box',
    padding: '$inputModal',
    width: '100%',
})

const StyledContent = styled('div', content)
const StyledContentInner = styled('div', contentInner)
const StyledHeader = styled('div', header)
const StyledFooter = styled('div', footer)

const CloseButton = styled(Button, closeButton)
const StyledHeading = styled('h1', heading)
const StyledText = styled('div', styledText)
const StyledIconWrapper = styled('div', iconWrapper)
const StyledButtons = styled('div', buttonsWrapper)

interface FormValues {
    name: string
}

const EmbedNamePromiseModalView = (props: EmbedPromiseModalProps): React.ReactElement => {
    const {
        onReject,
        onResolve,
        icon,
        text,
        title,
    } = props

    const {t} = useTranslation()
    const dispatch = useAppDispatch()
    const embed = useContext(EmbedContext)
    const theme = useContext(ThemeContext) as typeof embedTheme

    const {
        handleSubmit,
        register,
        control,
    } = useForm<FormValues>({
        defaultValues: {name: ''},
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
    })

    const reason = useWatch({
        control,
        name: 'name',
    })

    const onSubmit = (values: FormValues) => {
        dispatch(updateUser({user_attrs: {name: values.name}}))
            .unwrap()
            .then(() => {
                onResolve(values.name)
            })
    }

    const handleCloseModal = () => {
        // eslint-disable-next-line no-unused-expressions
        onReject && onReject()
    }

    return (
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        <Modal
            ariaLabelledby='modal-header'
            onClose={handleCloseModal}
            overlayBackground
            type='embedName'
            zIndex={theme.zIndices.embedModal.value}
        >
            <StyledHeader>
                <CloseButton
                    aria-label={t('Close modal')}
                    color='text'
                    // eslint-disable-next-line react/no-unstable-nested-components
                    iconLeft={() => <XIcon aria-label='Close' title='Close' />}
                    onPress={handleCloseModal}
                    tabIndex={-1}
                    text=''
                    type='button'
                />
            </StyledHeader>
            <StyledContent css={
                {$$headerHeight: `${embed?.containerOptions?.headerOptions?.height || DEFAULT_HEADER_HEIGHT}px`}
            }
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <StyledContentInner>

                        <StyledIconWrapper>{icon || <HeroUserCircleIcon aria-hidden='true' />}</StyledIconWrapper>
                        {!!title && <StyledHeading id='modal-header'>{title}</StyledHeading>}
                        {!!text && <StyledText>{text}</StyledText>}
                        <Input
                            {...register('name')}
                            autoFocus={true}
                            id='name'
                            placeholder={t('Enter your name')}
                            tabIndex={0}
                        />
                        <StyledButtons>
                            <Button
                                color='filled'
                                disabled={!!embed?.embedState.connectionError || !reason}
                                size='large'
                                tabIndex={0}
                                text={t('Send')}
                                type='submit'
                            />
                        </StyledButtons>
                    </StyledContentInner>
                </form>
            </StyledContent>
            <StyledFooter />
        </Modal>
    )
}

export default EmbedNamePromiseModalView
